import { Link } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { PRIVACY, TERMS } from "@/data/legal";
import { usePageMeta } from "@/lib/pageMeta";
import { useLang, useT } from "@/i18n";

const DOCS = { privacy: [PRIVACY, "/privacy-policy"], terms: [TERMS, "/termini-e-condizioni"] };

// Legal text page (privacy policy, terms): header, H1 + intro, sections, footer.
export default function LegalPage({ doc }) {
  const { lang } = useLang();
  const t = useT();
  const [data, path] = DOCS[doc];
  const c = data[lang] ?? data.it;
  usePageMeta({ title: c.title, desc: c.intro, path });
  return (
    <div className="bg-[#F7F5F0] text-[#121110]" data-testid={`legal-page-${doc}`}>
      <Nav />
      <main className="px-5 pb-24 pt-44 sm:px-8 lg:pt-52">
        <div className="mx-auto max-w-4xl">
          <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">{c.title}</h1>
          <p className="mt-5 text-sm leading-relaxed text-[#4A453F] sm:text-base">{c.intro}</p>
          <p className="mt-6 text-sm"><b>{c.owner[0]}:</b> {c.owner[1]}</p>
          {c.sections.map(([h, p]) => (
            <section key={h} className="mt-10">
              <h2 className="font-display text-xl font-bold tracking-tight">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[#4A453F] sm:text-base">{p}</p>
            </section>
          ))}
          <p className="mt-12 text-sm">
            <Link to="/cookie-policy" className="nav-link underline underline-offset-4" data-testid="legal-cookie-link">{t("ck.policy", "Cookie policy")}</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
